<template>
  <div class="app-body" ref="body">
    <app-header is-left left-text="个人信息" @click-left="goBack">
    </app-header>
    <van-cell-group title="">
      <van-cell title="头像">
        <img :src="headImage" style="display:inline-block; height:3rem;">
      </van-cell>
      <van-cell title="昵称">
        <div>{{ member.nickname }}</div>
      </van-cell>
      <van-cell title="注册时间">
        <div>{{ member.createtime }}</div>
      </van-cell>
      <van-cell title="收件地址" to="/user/address" is-link>
        <div slot="label">{{ memberaddress }}</div>
      </van-cell>
    </van-cell-group>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import tools from '@/utils/tools';
import AppHeader from '../app-header.vue';
export default {
  components: { AppHeader },
  mixins: [tools],
  data() {
    return {
    }
  },
  computed: {
    headImage() {
      let image = this.noimg;
      if (this.member.headpic) {
        if (this.member.headpic.isUrl()) {
          image = this.member.headpic;
        } else {
          image = this.rootPath + this.member.headpic;
        }
      }
      return image;
    },
    memberaddress() {
      let _address = '~还没有地址，点击添加收件地址';
      let address = this.member.address;
      if (address) {
        _address = '';
        if (address.name || address.tel) {
          _address += '【'+ (address.name || '') +' / '+ (address.tel || '') +'】'
        }
        _address += (address.province || '') + (address.city || '') + (address.county || '') + (address.address || '');
      }
      return _address;
    }
  },
  watch: {
  },
  created () {
  },
  mounted () {
    this.page = 1;
  },
  activated() {
  },
  methods: {
    goBack() {
      this.$router.push('/user');
    },
  }
}
</script>

<style lang="less" scoped>
.app-body{margin-top:46px; margin-bottom:50px; background-color:#fff;}
</style>